import React from 'react';
import { Icon } from '@iconify/react';

const RotablesDataTable = ({
  rotables,
  onView,
  onEdit,
  onDelete,
  onTransaction,
  transactionActions = [],
  isTransactionDisabled,
  loading,
  sortField,
  sortOrder,
  onSort,
}) => {
  const getSortIcon = (field) => {
    if (sortField !== field || !sortOrder) {
      return 'mdi:sort';
    }
    return sortOrder === 'asc' ? 'mdi:sort-ascending' : 'mdi:sort-descending';
  };

  const renderSortableHeader = (label, field) => {
    const ariaSort = sortField === field
      ? sortOrder === 'asc'
        ? 'ascending'
        : sortOrder === 'desc'
          ? 'descending'
          : 'none'
      : 'none';

    return (
      <th
        onClick={() => onSort?.(field)}
        style={{ cursor: 'pointer' }}
        scope="col"
        aria-sort={ariaSort}
      >
        <span className="d-inline-flex align-items-center gap-1">
          {label}
          <Icon className="text-xl" icon={getSortIcon(field)} />
        </span>
      </th>
    );
  };

  const getTaskLabel = (rotable) => {
    const codeName = rotable?.task?.code?.code;
    const taskName = rotable?.task?.code?.name;
    if (!codeName && !taskName) return '—';
    return [codeName, taskName].filter(Boolean).join(' - ');
  };

  return (
    <table className="table bordered-table mb-0 w-100 rounded-0">
      <thead>
        <tr>
          {renderSortableHeader('Serial Number', 'serialNumber')}
          {renderSortableHeader('Part Number', 'partNumber')}
          {renderSortableHeader('Description', 'description')}
          {renderSortableHeader('Status', 'status')}
          {renderSortableHeader('Repair Status', 'repairStatus')}
          {renderSortableHeader('Asset', 'asset')}
          <th>Task</th>
          {renderSortableHeader('Supplier', 'supplier')}
          <th>Location</th>
          {/*<th>Warranty</th>*/}
          <th className="text-nowrap">Actions</th>
        </tr>
      </thead>
      <tbody>
        {rotables.length === 0 && !loading && (
          <tr>
            <td colSpan={11} className="text-center py-4 rounded-0">
              No Rotables Loaded
            </td>
          </tr>
        )}
        {rotables.map((rotable) => (
          <tr key={rotable.id}>
            <td>
              <strong>{rotable.serialNumber}</strong>
            </td>
            <td>{rotable.part?.partNumber ?? rotable.partNumber ?? '—'}</td>
            <td>{rotable.part?.description}</td>
            <td>{rotable.status?.name || ''}</td>
            <td>{rotable.repairStatus?.name || ''}</td>
            <td>{rotable.task?.asset?.assetNumber ?? '—'}</td>
            <td>{getTaskLabel(rotable)}</td>
            <td>{rotable.supplier?.name || ''}</td>
            <td>
              {[rotable.zone, rotable.aisle, rotable.bay, rotable.shelf]
                .filter(Boolean)
                .join(' / ') || '—'}
            </td>            
            {/*<td>
              {rotable.warrantyStart || rotable.warrantyEnd
                ? `${formatIntDate(rotable.warrantyStart)} to ${formatIntDate(rotable.warrantyEnd)}`
                : '—'}
            </td>*/}
            <td>
              <div className="d-flex align-items-center gap-2">
                <button
                  className="view-btn w-32-px h-32-px bg-info-focus text-info-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  onClick={() => onView?.(rotable)}
                  aria-label="View rotable"
                >
                  <Icon icon="ic:baseline-visibility" />
                </button>
                <button
                  className="edit-btn w-32-px h-32-px bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center mx-6"
                  onClick={() => onEdit?.(rotable)}
                  aria-label="Edit rotable"
                >
                  <Icon icon="ic:baseline-edit" />
                </button>
                <button
                  className="delete-btn w-32-px h-32-px bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                  onClick={() => onDelete?.(rotable.id)}
                  aria-label="Delete rotable"
                >
                  <Icon icon="ic:baseline-delete-outline" />
                </button>
                <div className="dropdown">
                  <button
                    className="btn btn-link text-decoration-none text-body"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-label="Rotable actions"
                  >
                    <Icon icon="mdi:dots-vertical" className="text-xl" />
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end shadow">
                    {transactionActions.map((action) => {
                      if (action.type === 'divider') {
                        return (
                          <li key={action.key}>
                            <hr className="dropdown-divider" />
                          </li>
                        );
                      }
                      const disabled = isTransactionDisabled?.(rotable, action) ?? false;
                      return (
                        <li key={action.key}>
                          <button
                            className="dropdown-item d-flex align-items-center gap-2"
                            onClick={() => onTransaction?.(rotable, action)}
                            type="button"
                            disabled={disabled}
                          >
                            {action.icon && <Icon icon={action.icon} className="text-lg" />}
                            {action.label}
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        ))}
        {loading && (
          <tr>
            <td colSpan={11} className="text-center py-2">
              <span className="spinner-border spinner-border-sm" />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default RotablesDataTable;
